import { Typography, Box, useTheme } from "@mui/material";
import { tokens } from "../../../theme";

interface HeaderProps {
  title: string;
}

const Header = ({ title }: HeaderProps) => {
  const colors = tokens();
  return (
    <Box mb="5px">
      <Typography
        color={colors.grey[700]}
        fontWeight="bold"
        sx={{ m: "0 0 5px 0" }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export const HeaderSecondary = ({ title }: HeaderProps) => {
  const colors = tokens();
  return (
    <Box mb="5px">
      <Typography
        color={colors.grey[500]}
        fontWeight="bold"
        sx={{ m: "0 0 5px 0" }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default Header;
